import { graphql } from "gql.tada";
import { LinkFragment } from "@queries/fragments/LinkFragment";

export const InsightsBlockFragment = graphql(
  `
    fragment InsightsBlockFragment on InsightsBlocks {
      variant
      icon {
        url
      }
      category
      extraInfoLabel
      shortHighlightedValue
      mainText
      subtitle
      ctaLink {
        ...LinkFragment
      }
      bottomText
      backgroundImage {
        url
      }
    }
  `,
  [LinkFragment]
);
